import React from 'react';
import { Wrapper } from './styles.Scrolly';
import { TriggerConfig, useGlobal } from '../../logic/main';
import { ScrollyTeller, StepTrigger } from '../../components/custom/scrollyteller/ScrollyTeller';
import { boardConfig } from '../../config/boardConfig';
import { COLOR } from '../../styles/variables';
import { Description, DescriptionProps } from '../../components/custom/scrollyteller/styles.ScrollyTeller';
import styled, { StyledComponent } from 'styled-components';
import { withBorderCorner } from '../../styles/helper';
import { Position } from '../../config/models';

// @ts-ignore
export const Slide = styled(Description)`
    ${({ position }) => withBorderCorner(position === Position.RIGHT ? Position.LEFT : Position.RIGHT)}
` as StyledComponent<'div', any, DescriptionProps<TriggerConfig>, never>;

interface Props {
    skipLazyLoad?: boolean;
}

export const Scrolly: React.FC<Props> = ({ children, skipLazyLoad }) => {
    const [_, { setTrigger, setAllTriggers }] = useGlobal(
        _ => undefined,
        action => ({
            setTrigger: action.setCurrentTrigger,
            setAllTriggers: action.setAllTriggers
        })
    );

    const handleStepEnter: StepTrigger<TriggerConfig> = (index, id, direction, trigger) => {
        // console.log('ENTERING', { id, index, direction, trigger });
        setTrigger({
            ...trigger,
            index,
            id: id || trigger?.id,
            direction
        });
    };

    return (
        <ScrollyTeller
            onStepEnter={handleStepEnter}
            useFullHeight={true}
            wrapperWidth={'100%'}
            stickyWidth={'100%'}
            onAllTriggersLoaded={setAllTriggers}
            stickyPosition={undefined}
            isFixed={true}
            lazyLoad={!skipLazyLoad}
            descriptionWidth={'90%'}
            descriptionConfig={{
                lineWidth: 0,
                lineColor: COLOR.overlay
            }}
            stickyElement={<Wrapper useFullHeight={true} navbarHeight="0" id="canvas-wrapper" />}
        >
            {!boardConfig.debug ? children : null}
        </ScrollyTeller>
    );
};
